// WebKit before Safari 15.4 lacks AbortSignal#throwIfAborted and #reason, and
// core-js cannot polyfill them. Use these helpers instead of the native members.

export function abortReason(signal) {
  return signal.reason ?? new DOMException('The operation was aborted', 'AbortError');
}

export function throwIfAborted(signal) {
  if (signal?.aborted) throw abortReason(signal);
}
